export const toggleTheme = (e: MouseEvent): void => {
  e.preventDefault();
  e.stopPropagation();
  // if set via local storage previously
  if (localStorage.theme) {
    if (localStorage.theme === "light") {
      document.documentElement.classList.add("dark");
      localStorage.setItem("theme", "dark");
    } else {
      document.documentElement.classList.remove("dark");
      localStorage.setItem("theme", "light");
    }
    // if NOT set via local storage previously
  } else {
    document.documentElement.classList.add("dark");
    localStorage.setItem("theme", "dark");
  }
}

export function setupTheme(element: HTMLButtonElement | null): void {
  if (!element) {
    return;
  }
  element.addEventListener('click', (e: MouseEvent) => toggleTheme(e));
}

export function loadTheme(): void {
  if (localStorage.theme === 'dark') {
    document.documentElement.classList.add('dark')
  } else {
    document.documentElement.classList.remove('dark')
  }
}
